'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _onBlur = require('./onBlur');

var _onBlur2 = _interopRequireDefault(_onBlur);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Requires the following props:
 *  - stopEditing
 */
exports.default = function () {
  return {
    // Stop editing on escape
    onBlur: _onBlur2.default
  };
}; // Handlers


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/plugins/stopEditingOnBlur/index.js
// module id = 688
// module chunks = 0